import { connect } from 'react-redux'
import { lostCard } from './reducer'

const mapStateToProps = () => {
    return {}
}

const mapDispatchToProps = { lostCard }

const hocFormLostCard = (InnerComponent) => connect(mapStateToProps, mapDispatchToProps)(InnerComponent)

export default hocFormLostCard
